/* eslint-disable max-len */
import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';

import styled from 'styled-components';
import {
    colors,
    mobileMediaQuery,
    notWebMediaQuery,
    tabletMediaQuery,
} from './../../styles';

import * as ToastActions from '../../store/actions/toast';

const Container = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 62px;
    min-width: 25%;
    padding: 1rem 3rem;
    border-radius: 1.25rem;
    background-color: #fff;
    z-index: 99;
    transition: all 0.25s ease-in-out;
    color: ${colors.cartoonBlack};
    font-family: TTNormsProExtraBlack;
    font-size: 22px;
    ${props =>
        !props.active &&
        `
        opacity: 0;
    `};
    white-space: nowrap;

    ${notWebMediaQuery} {
        font-size: 16px;
        line-height: 24px;
    }

    ${tabletMediaQuery} {
        height: 72px;
        box-sizing: border-box;
        top: initial;
        bottom: 26%;
    }

    ${mobileMediaQuery} {
        height: 72px;
        width: 100vw;
        max-width: calc(100vw - 46px);
        left: 0px;
        right: 0px;
        box-sizing: border-box;
        margin: 0 23px;
        transform: initial;
        top: initial;
        bottom: 90px;

        white-space: pre-line;
        line-height: 24px;
        padding: 18px 20px 18px 30px;

        svg {
            min-width: 26px;
            margin-right: 24px;
        }
    }
`;

const Toast = ({active, value, delay, ...props}) => {
    let dispatch = useDispatch();

    const [hidden, setHidden] = useState(true);

    const [isActive, setIsActive] = useState(true);
    const [message, setMessage] = useState(value);

    useEffect(() => {
        if (active) {
            setMessage(value);
            setHidden(false);
            setIsActive(true);

            setTimeout(() => {
                setIsActive(false);
                dispatch(ToastActions.close());

                setTimeout(() => {
                    setHidden(true);
                }, 250);
            }, delay || 1500);
        }

        // eslint-disable-next-line
    }, [active, value]);

    return (
        !hidden && (
            <Container active={isActive} {...props}>
                {message}
            </Container>
        )
    );
};

export default Toast;
